define('TescoMobile_ClubCard/js/view/account/clubcard-modal',['jquery', 'uiComponent', 'Magento_Customer/js/customer-data', "Magento_Ui/js/modal/modal", 'jquery/jquery-storageapi'], function ($, Component, customerData, modal) {
  'use strict';

  const storage = $.initNamespaceStorage('tm-clubcard-modal-storage').localStorage;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_ClubCard/account/clubcard-modal',
      modalTitle: '<div class="clubcard-logo"><span>Lower prices</span> <span>Clubcard Price</span></div> Get an unbeatable value with your Clubcard<span class="dot">.</span>'
    },
    initObservable: function () {
      this._super();
      this.observe(['isLinkedClubcard']);
      return this;
    },
    initialize: function () {
      this._super();
      const customer = customerData.get('customer');
      this.customerDataUpdate(customer());
      customer.subscribe(this.customerDataUpdate, this);
    },
    customerDataUpdate: function (data) {
      this.isLinkedClubcard(data === null || data === void 0 ? void 0 : data.has_linked_clubcard);
      this.animateIcon();
    },
    animateIcon: function () {
      if (this.isLinkedClubcard() === false && storage.get('tmIsAnimatedIconClicked') !== true) {
        $('li.customer-account-menu-clubcard').addClass('blink');
      }
    },
    initModal: function (element) {
      const options = {
        type: 'slide',
        responsive: true,
        modalClass: 'dashboard-clubcard-modal',
        title: this.modalTitle
      };
      const popup = modal(options, $(element));
      $(this.modalTrigger).on('click', function (event) {
        if (this.isLinkedClubcard() === undefined || this.isLinkedClubcard() === true) {
          return;
        }
        event.preventDefault();
        $(element).modal('openModal');
        storage.set('tmIsAnimatedIconClicked', true);
        return false;
      }.bind(this));
    }
  });
});

